import { Link } from 'react-router-dom'
import type { ProductDef } from './registry'
import { useProductFeed } from '@/lib/feeds/client'

/** A single product entry tile. Shows a live thumbnail from the feed when available. */
export function ProductTile({ product, compact = false }: { product: ProductDef; compact?: boolean }) {
  const { data } = useProductFeed(product.feedUrl)
  const Icon = product.icon
  const thumb = data?.latest?.url

  return (
    <Link
      to={`/products/${product.id}`}
      className={`ptile${compact ? ' ptile--compact' : ''}`}
      style={{ '--accent': product.accent } as React.CSSProperties}
    >
      <div className="ptile__media">
        {thumb ? (
          <img src={thumb} alt="" loading="lazy" className="ptile__img" />
        ) : (
          <div className="ptile__placeholder">
            <Icon size={compact ? 26 : 30} strokeWidth={1.5} />
          </div>
        )}
        <span className="ptile__badge">
          <Icon size={14} />
        </span>
        {product.id === 'radar' && <span className="ptile__sweep" aria-hidden />}
      </div>
      <div className="ptile__text">
        <span className="ptile__title">{product.title}</span>
        {!compact && <span className="ptile__sub">{product.subtitle}</span>}
      </div>
    </Link>
  )
}
